export type CsvCell = string | number;

function csvEscape(value: CsvCell): string {
  const valueString = String(value);
  if (valueString.includes('"') || valueString.includes(',') || valueString.includes('\n')) {
    return `"${valueString.replace(/"/g, '""')}"`;
  }
  return valueString;
}

export function serializeCsvRow(cells: CsvCell[]): string {
  return cells.map(csvEscape).join(',');
}

export function downloadCsv(filename: string, lines: string[]): void {
  const content = lines.join('\n');
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();

  URL.revokeObjectURL(url);
}
